import { setupTracking } from '@/utils/tracking.js';

export default ({ app }) => {
  if (process.client) {
    const urlParams = new URLSearchParams(window.location.search);
    setupTracking(urlParams, app.$cookies);

    // Re-run on client-side route changes so campaign params in internal
    // links (e.g. /ucretsiz-demo-talep/?utm_source=google) are captured.
    app.router.afterEach((to) => {
      const query = to.fullPath.split('?')[1];
      if (query) {
        setupTracking(new URLSearchParams(query), app.$cookies);
      }
    });
  }
};
